/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import parameters from '@jira/servicedesk__solution-composer-embeds/src/__generated__/QueueSettingsEmbeddedViewQuery$parameters.ts';
import type { QueueSettingsEmbeddedViewQuery } from '@jira/servicedesk__solution-composer-embeds/src/__generated__/QueueSettingsEmbeddedViewQuery.graphql.ts';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type QueueSettingsEmbeddedViewEntryPointComponent = EntryPointComponent<
	{
		queueSettingsQuery: QueueSettingsEmbeddedViewQuery;
	},
	{},
	{},
	{
		projectKey: string;
	}
>;

export const gettingStartedQueueSettingsEntryPoint: EntryPoint<
	QueueSettingsEmbeddedViewEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<QueueSettingsEmbeddedViewEntryPointComponent>(
		/* webpackChunkName: "async-servicedesk-getting-started-queues", jiraSpaEntry: "async-servicedesk-getting-started-queues" */ '@jira/servicedesk__solution-composer-embeds/src/QueueSettingsEmbeddedView.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: ({ context: { match }, tenantContext: { cloudId } }: EntryPointRouteParams) => {
		const projectKey = match.params.projectKey ?? '';

		return {
			queries: {
				queueSettingsQuery: {
					parameters,
					variables: {
						cloudId,
						projectKey,
					},
					options: {
						fetchPolicy: 'store-and-network' as const,
					},
				},
			},
			extraProps: {
				projectKey,
			},
		};
	},
});
